query TripBreakdown($id: UUID!) {
  tripBreakdown(id: $id) {
    id
    tripLocator
    _rowTimestamp
    travelerReferenceName
    travelAuthorizationNumber
    comment
    travelAuthorizationDate
    _departmentName
    _isoCode
    airfareAmount
    budgetAmount
    accommodationAmount
    vehicleRentalAmount
    transportationAmount
    trainAmount
    otherAmount
    controlTotalAmount
    _isOverBudget
    airfareBudgetAmount
    _isAirfareOverBudget
    accommodationBudgetAmount
    _isAccommodationOverBudget
    vehicleRentalBudgetAmount
    _isVehicleRentalOverBudget
    transportationBudgetAmount
    _isTransportationOverBudget
    trainBudgetAmount
    _isTrainOverBudget
    incidentalAmount
    incidentalBudgetAmount
    _isIncidentalOverBudget
    _taStatusType
    _isAccommodationExist
    _isTrainExist
    _isVehicleRentalExist
    _isTransportationExist
    _isIncidentalExist
    _isAirfareExist
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    travelAuthorization {
      id
      _rowTimestamp
      _isUpdatable
      _isDistributionUpdateAllowed
      bookingFee
    }
    tripPurpose
    _businessUnitName
    _baseIsoCode
    _baseCurrencyAmount
    _spotCurrencyAmount
    _createdDate
    _createdByUserName
  }
}
